import React from "react";
const AboutHeroSection = ({ title, highlight, afterHighlight, description, image }) => {
  return (
    <div className="about-hero-section padding-container">
      <div className="page-wrapper">
        <div className="secondary-m1">
          <div className="secondary-hero">

            {/* Left Text Section */}
            <div className="secondary-hero-text">
              <h1>
                {title}{" "}
                <span className="orange-text">{highlight}</span>{" "}
                {afterHighlight}
              </h1>
              <p>{description}</p>
            </div>

            {/* Right Image Section */}
            <div className="secondary-hero-img">
              <img src={image} alt="About Section" width="100%" />
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutHeroSection;
